import {Dialog, DialogContent, DialogTitle, IconButton, Stack, Typography} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import {KeySnapshot} from "../../api/Model";
import {KeyOperationPanel} from "../key-operations/KeyOperationPanel";

export function KeyOperationDialog({keySnapshot, open, onClose}: {
    keySnapshot: KeySnapshot,
    open: boolean,
    onClose: () => void,
}) {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth={true}
            maxWidth="lg"
        >
            <DialogTitle sx={{bgcolor: 'primary.main', color: 'primary.contrastText', mb: 2, px: 3}}>
                <Stack direction="row" gap={4} alignItems="center" justifyContent="space-between">
                    <Typography variant="h6" component="span">
                        {keySnapshot.key.keyNumber}: Key Operation
                    </Typography>
                    <IconButton onClick={onClose}>
                        <CloseIcon sx={{color: 'primary.contrastText'}}/>
                    </IconButton>
                </Stack>
            </DialogTitle>
            <DialogContent>
                <KeyOperationPanel
                    keySnapshot={keySnapshot}
                    onFinish={onClose}
                />
            </DialogContent>
        </Dialog>
    );
}
